import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-number-input/style.css';

import "../src/Style/global.scss";
import "../src/Style/style.scss";
import "../src/Style/responsive.scss";

import { Provider } from 'react-redux';
import Store from './Store/store';
import { GoogleOAuthProvider } from '@react-oauth/google';

// The risk gauge re-measures itself inside one frame, so the browser reports this harmless notice.
// The CRA dev overlay shows it as an error, so the overlay is hidden for this message only.
const RESIZE_OBSERVER_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
];

window.addEventListener('error', (event) => {
  if (RESIZE_OBSERVER_MESSAGES.includes(event.message)) {
    document.getElementById('webpack-dev-server-client-overlay')?.setAttribute('style', 'display: none');
    document.getElementById('webpack-dev-server-client-overlay-div')?.setAttribute('style', 'display: none');
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_SECRET_ID}>
    <Provider store={Store}>
      <App />
    </Provider>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
